import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from './loader.service';
import { getLogo } from 'src/app/shared/utils/configSource';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent implements OnInit {


  constructor (private loaderService: LoaderService) {}

  logoShort = getLogo.logoShort
  public loading: Subject<boolean>
  public message$: Subject<string | null>
  async ngOnInit() {
    this.loading = await this.loaderService.isLoading;
    this.message$ = this.loaderService.message;
  }


  


}
